import React from "react";
import {isMobile} from "../helper";

const RightArrowSvg = ({
  active,
  onClick,
}: {
  active: boolean;
  onClick: () => void;
}): React.ReactElement => {
  return (
    <div
      className={
        "week-navigation-right hoverable " +
        (isMobile() ? "isMobile isMobile-padding " : "") +
        (active ? "" : "week-navigation-disabled ")
      }
      onClick={onClick}
    >
      <svg
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.294922 10.59L4.87492 6L0.294921 1.41L1.70492 -6.16331e-08L7.70492 6L1.70492 12L0.294922 10.59Z"
          fill={active ? "#5582A8" : "#8CADCB"}
        />
      </svg>
    </div>
  );
};

export default RightArrowSvg;
